import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import HomeIcon from "../../icons/menu/home";
import JobSuggestIcon from "../../icons/menu/job_suggest";
import ProfileIcon from "../../icons/menu/profile";
import TestIcon from "../../icons/menu/test";
import WorkIcon from "../../icons/menu/work";
import NavigationRenderer from "../NavigationRenderer";
import TrainingIcon from "../../icons/menu/training";
import ResourcesMenuIcon from "../../components/ressources/ResourcesMenuIcon";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

const AdvisorContextMenu: React.FC<{
  handleLinkClick: any;
}> = ({ handleLinkClick }: any) => {
  const { t } = useTranslation("common");
  const context = useSelector((state: any) => state.auth.context);
  const menu = useSelector((state: any) => state.menu);
  const isCES = useSelector((state: any) => state.user.isCES);
  const location = useLocation();
  const links = [
    {
      icon: (
        <HomeIcon
          active={location.pathname.includes("app/home")}
          context={context}
          size={25}
        />
      ),
      label: t("home"),
      path: "/app/home",
      active: location.pathname.includes("app/home"),
    },
    !isCES && {
      label: t("common_advisor.folder.label_title_plural", { context }),
      icon: (
        <TestIcon
          active={location.pathname.includes("folder")}
          context={context}
          size={25}
        />
      ),
      path: "/app/folder/list",
      active: location.pathname.includes("folder"),
    },
    {
      label: t("common_advisor.profile.label_title_plural", { context }),
      icon: (
        <ProfileIcon
          active={location.pathname.includes("employee")}
          context={context}
          size={25}
        />
      ),
      path: "/app/employee/list",
      active: location.pathname.includes("employee"),
    },
    menu?.third_party && {
      label: t("third_party.label"),
      icon: <PeopleAltIcon />,
      path: "/app/third_party/list",
      active: location.pathname.includes("third_party"),
    },
    menu?.works && {
      icon: (
        <WorkIcon
          active={location.pathname.includes("app/work")}
          context={context}
          size={25}
        />
      ),
      label: t("work_suggest.work_label"),
      path: "/app/work/list",
      active: location.pathname.includes("app/work"),
    },
    menu?.trainings && {
      icon: (
        <TrainingIcon
          active={location.pathname.includes("trainings/list")}
          context={context}
          size={25}
        />
      ),
      label: t("trainings.page"),
      path: "/app/trainings/list",
      active: location.pathname.includes("trainings/list"),
    },
    menu?.jobs && {
      icon: (
        <JobSuggestIcon
          active={location.pathname.includes("job/suggest")}
          context={context}
          size={25}
        />
      ),
      label: t("job_suggest.title"),
      path: "/app/job/suggest",
      active: location.pathname.includes("job/suggest"),
    },
    menu?.resources && {
      icon: <ResourcesMenuIcon />,
      label: t("resources.title"),
      path: "/app/resources",
      active: location.pathname.includes("resources"),
    },
  ].filter((el) => el && el !== false);

  return <NavigationRenderer links={links} handleLinkClick={handleLinkClick} />;
};

export default AdvisorContextMenu;
